


















import { IVideoItem } from "@/types";
import Vue from "vue";
import { store } from "../services/store";

import VideoCard from "./VideoCard.vue";

export default Vue.extend({
  name: "Videos",
  components: {
    VideoCard
  },
  computed: {
    videoList(): IVideoItem[] {
      return store.videoList;
    }
  }
});
